import * as React from 'react';
import styled from 'styled-components';
import {
	appHeaderGap,
	appHeaderProgressLineHeight,
	appHeaderWrapperHeightV2,
	bottomNavBarV2Height,
	appFooterV2Height,
	newContentPadding,
	simpleViewMaxWidth,
	tabletPortraitMinWidth,
	greyBackground
} from '../../cssConstants';
import { pixelsToNumber, isAndroidApp } from '../../../lib/utils';
import useSoftKeyboardHeightStore from '../../../zustandStore/softKeyboardHeightStore';
import { isLoggedIn } from '../../../core/localStorage';

const Content = ({ children, widerView, showHeader, showFooter, headerHasProgressLine }: Props) => {
	const softKeyboardHeight = useSoftKeyboardHeightStore((state) => state.softKeyboardHeight);

	return (
		<ContentWrapper
			$bottomGapForSoftKeyboard={softKeyboardHeight}
			$widerView={widerView}
			$showHeader={showHeader}
			$showFooter={showFooter}
			$headerHasProgressLine={headerHasProgressLine}
		>
			{children}
		</ContentWrapper>
	);
};

interface Props {
	children: React.ReactNode;
	widerView: boolean;
	showHeader: boolean;
	showFooter: boolean;
	headerHasProgressLine: boolean;
}

export default Content;

export const getContentPaddingTop = (showHeader = true, headerHasProgressLine = false) =>
	(showHeader ? pixelsToNumber(appHeaderWrapperHeightV2) : 0) +
	(headerHasProgressLine ? pixelsToNumber(appHeaderProgressLineHeight) : 0) +
	pixelsToNumber(appHeaderGap);

const getMinHeight = (showFooter: boolean, bottomGapForSoftKeyboard: number) => {
	let minHeight = pixelsToNumber(newContentPadding) + bottomGapForSoftKeyboard;

	if (isLoggedIn()) {
		minHeight += pixelsToNumber(bottomNavBarV2Height);
	}
	if (showFooter) {
		minHeight += pixelsToNumber(appFooterV2Height);
	}
	return minHeight;
};

const ContentWrapper = styled.section<{
	$widerView: boolean;
	$showHeader: boolean;
	$showFooter: boolean;
	$bottomGapForSoftKeyboard: number;
	$headerHasProgressLine: boolean;
}>`
	flex: 1; /* Allows the main content to expand and push the footer down */
	background-color: ${greyBackground};
	margin: auto auto ${(props) => (props.$bottomGapForSoftKeyboard ? `${props.$bottomGapForSoftKeyboard}px` : 'auto')}
		auto;
	max-width: ${(props) => (props.$widerView ? '100vw' : simpleViewMaxWidth)};
	padding-top: ${(props) => `${getContentPaddingTop(props.$showHeader, props.$headerHasProgressLine)}px`};
	padding-bottom: ${isAndroidApp ? 'var(--safe-area-inset-bottom)' : '0'};
	min-height: ${(props) => `calc(100vh - ${getMinHeight(props.$showFooter, props.$bottomGapForSoftKeyboard)}px)`};

	label {
		font-size: 14px;
		font-weight: 400;
	}

	input.MuiInputBase-input {
		padding-top: 19px; // was 21px from MUI
	}

	input.MuiInputBase-input,
	textarea.MuiInputBase-input,
	div:has(+ input.MuiInputBase-input) {
		font-size: 16px; // TODO: May not need this anymore as I changed Input font size to 16px
		font-weight: 400;

		@media (min-width: ${tabletPortraitMinWidth}) {
			font-size: 18px;
		}
	}

	button {
		box-shadow: none;

		&:hover {
			box-shadow: none;
		}
	}

	/* Safari applies different margin collapsing rules, set 0 margin bottom as Layout has 16px padding already to prevent scroll issue. */
	/* TODO: Find a better way to handle all last child */
	& > :last-child,
	& > :last-child > :last-child,
	& > :last-child > :last-child > :last-child,
	& > :last-child > :last-child > :last-child > :last-child {
		margin-bottom: 0 !important;
	}
`;
